import {
  IActiveSubscription,
  ICheckoutSubscriptionOutput,
  IPlanList,
  IRenewalCouponResponse,
  IRenewalOfferResponse,
  ISubscriptionActivitySummary,
  IValidateDiscountResponse,
  IVerifySubscription,
  OCouponValidate,
  SUBSCRIPTION_SELECT_PAY_WAY,
} from "types/subscription";
import gate from "../gate";
import client from "../http-clients/api";

const subscriptionApi = {
  getPlans: () =>
    gate.get<IPlanList, never, never>({
      client,
      url: "/subscription/plans",
    }),

  purchase: (data: {
    plan_id: number;
    platform: "web";
    gateway: SUBSCRIPTION_SELECT_PAY_WAY;
    coupon_code: string | null;
    use_credit: boolean;
  }) =>
    gate.post<
      ICheckoutSubscriptionOutput,
      {
        plan_id: number;
        platform: "web";
        gateway: SUBSCRIPTION_SELECT_PAY_WAY;
        coupon_code: string | null;
        use_credit: boolean;
      },
      never
    >({
      client,
      url: `/subscription/purchase`,
      data: data,
    }),
  verify: (order_id: Number, status: boolean) =>
    gate.get<IVerifySubscription, { order_id: Number; status: boolean }, never>(
      {
        client,
        url: `/subscription/verify`,
        data: { order_id, status },
      }
    ),
  checkUserPlan: () =>
    gate.get<IActiveSubscription, never, never>({
      client,
      url: `/subscription/status`,
    }),
  validateDiscount: (data: OCouponValidate) =>
    gate.post<IValidateDiscountResponse, OCouponValidate, never>({
      client,
      url: `/subscription/coupon/validate`,
      data: data,
    }),

  getUserSubscriptionSummary: () =>
    gate.get<ISubscriptionActivitySummary, never, never>({
      client,
      url: "/subscription/activity-summary",
    }),

  getRenewalOffer: () =>
    gate.get<IRenewalOfferResponse, never, never>({
      client,
      url: "/subscription/renewal-offer",
    }),

  createRenewalCoupon: () =>
    gate.post<IRenewalCouponResponse, never, never>({
      client,
      url: "/subscription/renewal-coupon",
    }),
};

export default subscriptionApi;
